import {
    SWITCH_TO_PATTERN,
    PLAY_WORK,
    LOAD_WORK,
    UNLOAD_WORK,
    CHANGE_TRANSPOSE,
    CHANGE_VOLUME,
    CHANGE_BPM,
    CHANGE_COLOR,
    ROLL_ON,
    ROLL_OFF
} from './constants.js';

export const switchToPattern =
    (sequenceId, subSequenceId, patternNumber) => ({
        type: SWITCH_TO_PATTERN,
        sequenceId,
        subSequenceId,
        patternNumber
    });

export const playWork =
    (work) => ({
        type: PLAY_WORK,
        work,
        isTransport: true
    });

export const loadWork =
    (work) => ({
        type: LOAD_WORK,
        work
    });

export const unloadWork =
    (work) => ({
        type: UNLOAD_WORK,
        work
    });

export const changeTranspose =
    (sequenceId, transpose) => ({
        type: CHANGE_TRANSPOSE,
        sequenceId,
        transpose
    });

export const changeVolume  =
    (sequenceId, volume) => ({
        type: CHANGE_VOLUME,
        sequenceId,
        volume
    });

export const changeColor=
    (sequenceId, color) => ({
        type: CHANGE_COLOR,
        sequenceId,
        color
    });

export const changeBPM =
    (bpm) => ({
        type: CHANGE_BPM,
        bpm
    });

export const rollOn =
    (resolution) => ({
        type: ROLL_ON,
        resolution
    });

export const rollOff =
    () => ({
        type: ROLL_OFF
    });






